module.exports = __webpack_public_path__ + "img/areiopagos.81300831.png";